module.exports = __webpack_public_path__ + "static/media/standardHashrate.adcbb68f.png";